document.addEventListener("turbolinks:load", () => {
  const signInForm = document.getElementById("sign-in-form");
  if (!(signInForm && signInForm instanceof HTMLFormElement)) {
    return;
  }

  setTimeout(() => signInForm.submit(), 1000);
});
